export default __webpack_public_path__ + "static/media/saco-hombre.a11dc581.png";